<template>
	<v-dialog scrollable persistent v-model="showDialog" max-width="820">
		<v-card>
			<v-card-title>Report</v-card-title>

			<v-card-text>
				<v-form ref="form">
					<v-row no-gutters>
						<v-text-field
							label="Report Name"
							v-model="reportName"
							:rules="[rules.required, rules.max30Chars]"
						/>
					</v-row>
					<v-row no-gutters>
						<v-select
							:disabled="reportTypeDisabled"
							label="Report Type"
							item-value="value"
							item-text="label"
							:items="reportTypeItems"
							v-model="reportType"
							:rules="[rules.required]"
						/>
					</v-row>
					<v-row no-gutters v-if="hasCustomData">
						<v-text-field
							:disabled="dataSourceDisabled"
							label="Data Source"
							v-model="customData"
							:rules="[rules.required]"
						>
							<template v-slot:prepend v-if="hasCustomData">
								<v-tooltip
									right
									nudge-top="25"
									:open-on-hover="true"
								>
									<template v-slot:activator="{ on, attrs }">
										<v-icon
											color="primary"
											v-bind="attrs"
											v-on="on"
											>mdi-information-outline</v-icon
										>
									</template>
									For the custom data to work, you need a view
									defined in the database
								</v-tooltip>
							</template>
						</v-text-field>
					</v-row>
					<v-row no-gutters v-else>
						<v-select
							:disabled="dataSourceDisabled"
							:items="gridViews"
							item-value="Id"
							item-text="Name"
							label="Data Source"
							v-model="gridViewId"
							:rules="[rules.required]"
						/>
					</v-row>
				</v-form>
			</v-card-text>
			<v-divider />

			<v-card-actions>
				<v-spacer />
				<v-btn @click.stop="onClose">Close</v-btn>
				<v-btn color="primary" @click.stop="onSave">
					<v-icon class="mr-2">mdi-content-save</v-icon>
					Save
				</v-btn>
			</v-card-actions>
		</v-card>
	</v-dialog>
</template>

<script>
import { ReportDetailsActions } from '../../../store/actions';
import { reportTypes } from '../../../enums/reportTypes';
import { mapGetters } from 'vuex';
import { ReportDetailsGetters } from '../../../store/getters';
export default {
	name: 'ReportModal',
	props: {
		report: Object,
		showDialog: Boolean,
	},
	watch: {
		reportType(newVal) {
			if (newVal === reportTypes.RAW_DATA) {
				this.customData = null;
			}

			if (newVal === reportTypes.CUSTOM_DATA) {
				this.gridViewId = null;
			}
		},
	},
	computed: {
		...mapGetters({
			gridViews: [ReportDetailsGetters.DATA_SOURCES_RAW_DATA],
		}),
		reportTypeDisabled() {
			if (this.report) return true;
			return false;
		},
		dataSourceDisabled() {
			if (this.reportTypeDisabled) return true;
			if (this.reportType) return false;
			return true;
		},
		hasCustomData() {
			if (!this.reportType) return false;
			return this.reportType == reportTypes.CUSTOM_DATA;
		},
	},
	data() {
		return {
			reportName: null,
			reportType: null,
			gridViewId: null,
			customData: null,
			reportTypeItems: [
				{ label: 'Default Data', value: reportTypes.RAW_DATA },
				{ label: 'Custom Data', value: reportTypes.CUSTOM_DATA },
			],
			rules: {
				required: (value) => !!value || 'Field is required',
				max30Chars: (value) =>
					(value && value.length <= 30) ||
					'Field must be 30 characters or less',
			},
		};
	},
	mounted() {
		this.$store.dispatch(ReportDetailsActions.LOAD_GRIDVIEWS);
		if (this.report) {
			this.reportName = this.report.Name;
			this.reportType = this.report.Type;
			this.gridViewId = this.report.GridViewId;
			this.customData = this.report.CustomData;
		}
	},
	destroyed() {
		this.$store.dispatch(ReportDetailsActions.CLEAR);
	},
	methods: {
		onClose() {
			this.$emit('close');
		},
		onSave() {
			if (!this.$refs.form.validate()) return;
			if (!this.report) {
				let report = {
					Name: this.reportName,
					Type: this.reportType,
					GridViewId: this.gridViewId,
					CustomData: this.customData,
				};
				this.$store
					.dispatch(ReportDetailsActions.ADD_REPORT, report)
					.then((resp) => {
						if (!resp) return;
						this.$router.push({
							name: 'ReportDetails',
							params: { reportId: resp.Id },
						});
					});
			} else {
				this.report.Name = this.reportName;

				this.$store
					.dispatch(ReportDetailsActions.UPDATE_REPORT, this.report)
					.then(() => {
						this.$emit('close');
					});
			}
		},
	},
};
</script>
